const FORMULA_API_ENDPOINTS = {
  FUNDS: "/apis/novata/excel-addin/funds",
  COMPANIES: "/apis/novata/excel-addin/companies",
  METRICS: "/apis/novata/excel-addin/metrics",
  REPORTS: "/apis/novata/excel-addin/reports",
  ANSWERS: "/apis/novata/excel-addin/answers",
  SCORECARDS: "/apis/novata/excel-addin/scorecards",
};

const FUND_ATTRIBUTE_MAP = {
  fund_name: "name",
  fund_currency: "currency",
  fund_op_region: "operatingRegions",
  fund_operating_region: "operatingRegions",
  fund_country: "countryOfDomicile",
  fund_inv_region: "investmentRegions",
  fund_investment_region: "investmentRegions",
  fund_type: "fundType",
  sub_fund_type: "subFundType",
  fund_classification: "fundClassification",
  fund_vintage: "fundCreationYear",
  fund_size: "fundSizeInMillions",
  edci_fund_id: "edciFundId",
  fund_curren: "currency",
  fund_op_reg: "operatingRegions",
  fund_operating_regions: "operatingRegions",
  fund_countr: "countryOfDomicile",
  fund_country_of_domicile: "countryOfDomicile",
  fund_inv_reg: "investmentRegions",
  fund_investment_regions: "investmentRegions",
  sub_fund_ty: "subFundType",
  fund_classif: "fundClassification",
  fund_creation_year: "fundCreationYear",
  fund_size_in_millions: "fundSizeInMillions",
  edci_fund_ic: "edciFundId",
  custom_id: "customId",
  fund_status: "fundStatus",
  ownership_percentage: "ownershipPercentage",
};

const METRIC_FIELD_MAP = {
  metric_name: "name",
  metric_definition: "fullDefinition",
  metric_definition_summary: "definitionSummary",
  metric_type: "inputTypeId",
  metric_unit: "unit",
  metric_guidance: "guidance",
  metric_guidance_content: "guidanceContent",
};

const COMPANY_ATTRIBUTE_MAP = {
  fund_name: "name",
  company_structure: "companyStructure",
  company_yoi: "yearOfIncorporation",
  company_sics_sector: "sicsSector",
  company_sics_industry: "sicsIndustry",
  company_gics_industry: "gicsIndustry",
  company_gics_subindustry: "gicsSubIndustry",
  company_edci_subindustry: "edciSubIndustry",
  company_deal_sector: "dealSector",
  company_deal_subsector: "dealSubSector",
  company_edci_growth_stage: "edciGrowthStage",
  company_currency: "currency",
  company_op_region: "operatingRegions",
  company_country: "countryOfDomicile",
  company_country_revenue: "primaryCountryRevenue",
  company_country_FTE: "primaryCountryFTE",
  company_revenue: "annualRevenue",
  company_investment_year: "yearOfIncorporation",
  company_gp_ownership: "gpOwnership",
  company_fund_ownership: "fundOwnership",
};

const ANSWER_ATTRIBUTE_MAP = {
  answer: "answer",
  context_for_answer: "context",
  custom_metric: "customMetric",
  metric_enr: "metricReported",
  metric_enr_reason: "metricNotReportedReason",
  metric_input_type: "metricInputType",
  metric_name: "metricName",
  metric_reference: "metricReference",
  metric_visible: "metricVisible",
  metric_visible_reason: "metricVisibleReason",
  metric_unit_desc: "metricUnit",
  metric_unit_suffix: "metricUnitSuffix",
  report_status: "reportStatus",
};

const REPORT_ATTRIBUTE_MAP = {
  data_provider_name: "dataProviderName",
  data_provider_sics_industry: "dataProviderSicsIndustry",
  framework_name: "frameworkName",
  report_completion: "reportCompletion",
  report_created_at: "reportCreatedAt",
  report_due_date: "reportDueDate",
  report_name: "reportName",
  report_period_frequency: "reportPeriodFrequency",
  report_period_start: "reportPeriodStart",
  report_status: "reportStatus",
  report_submitted_at: "reportSubmittedAt",
  report_updated_at: "reportUpdatedAt",
  reporting_period: "reportingPeriod",
};

const SCORE_ATTRIBUTE_MAP = {
  score: "score",
  min_score: "minScore",
  max_score: "maxScore",
  aggregation_method: "aggregationMethod",
  is_completed: "isCompleted",
  is_stale: "isStale",
  last_generated_at: "lastGeneratedAt",
};

const CATEGORY_ATTRIBUTE_MAP = {
  score: "score",
  max_score: "maxScore",
  weight: "weight",
};

const QUESTION_ATTRIBUTE_MAP = {
  display_value: "displayValue",
  numeric_value: "numericValue",
  score: "score",
  metric_reference: "metricReference",
  context: "context",
};

export {
  FORMULA_API_ENDPOINTS,
  FUND_ATTRIBUTE_MAP,
  METRIC_FIELD_MAP,
  COMPANY_ATTRIBUTE_MAP,
  ANSWER_ATTRIBUTE_MAP,
  REPORT_ATTRIBUTE_MAP,
  SCORE_ATTRIBUTE_MAP,
  CATEGORY_ATTRIBUTE_MAP,
  QUESTION_ATTRIBUTE_MAP,
};
